var ColorFunctions;
(function(ColorFunctions) {
    ColorFunctions["PRIMARY"] = "PRIMARY";
    ColorFunctions["SECONDARY"] = "SECONDARY";
    ColorFunctions["POSITIVE"] = "POSITIVE";
    ColorFunctions["CAUTION"] = "CAUTION";
    ColorFunctions["NEGATIVE"] = "NEGATIVE";
})(ColorFunctions || (ColorFunctions = {}));

export { ColorFunctions };
